import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _PlainTextInput;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import { htmlEncode } from 'htmlencode';
import { TextArea } from '@instructure/quiz-common';
import extractTextFromHtml from '../../../../../util/extractTextFromHtml';
var PlainTextInput = /*#__PURE__*/function (_Component) {
  function PlainTextInput() {
    var _this2;
    _classCallCheck(this, PlainTextInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, PlainTextInput, [].concat(args));
    _defineProperty(_this2, "handleChange", function (event) {
      var escaped = htmlEncode(event.target.value);
      _this2.props.onChange(event, escaped);
    });
    _defineProperty(_this2, "handleRef", function (node) {
      _this2.textarea = node;
      _this2.props.textareaRef && _this2.props.textareaRef(node);
    });
    return _this2;
  }
  _inherits(PlainTextInput, _Component);
  return _createClass(PlainTextInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.focusOnMount) {
        this.textarea.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(TextArea, Object.assign({
        defaultValue: extractTextFromHtml(this.props.defaultValue),
        onChange: this.handleChange,
        textareaRef: this.handleRef
      }, omit(this.props, Object.keys(this.constructor.plainTextInputTypes)), {
        autoGrow: this.context.disableTextAreaAutoGrow ? false : this.props.autoGrow
      }));
    }
  }]);
}(Component);
_PlainTextInput = PlainTextInput;
_defineProperty(PlainTextInput, "plainTextInputTypes", {
  defaultValue: PropTypes.string,
  focusOnMount: PropTypes.bool,
  onChange: PropTypes.func,
  textareaRef: PropTypes.func
});
_defineProperty(PlainTextInput, "propTypes", _objectSpread(_objectSpread({}, TextArea.propTypes), _PlainTextInput.plainTextInputTypes));
_defineProperty(PlainTextInput, "defaultProps", _objectSpread(_objectSpread({}, TextArea.defaultProps), {}, {
  defaultValue: void 0,
  focusOnMount: false,
  onChange: Function.prototype,
  textareaRef: Function.prototype,
  required: false
}));
_defineProperty(PlainTextInput, "contextTypes", {
  disableTextAreaAutoGrow: PropTypes.bool
});
export { PlainTextInput as default };